import { render } from "./FormatItalic.vue?vue&type=template&id=3cb7538c"
import script from "./FormatItalic.vue?vue&type=script&lang=js"
export * from "./FormatItalic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__